import { Box } from "@mui/material";
import React from "react";
import PaymentCard from "./PaymentCard";
import CombinationCard from "./CombinationCard";
import YourBookingCard from "./YourBookingCard";
import AddressCard from "./AddressCard";
import { useSelector } from "react-redux";

const CardSection = ({
    totalCount,
    languageWords,
    reservType,
    selectedDate,
    adult,
    child,
    kid,
    baby,
    toddler,
    selectedExtraProduct,
    time,
    transactionDetails,
    selectedCombination,
    transactionPrice,excludingVat,totalVat,totalIncludingVAT,
    totalCostYourBooking
    
}) => {
    const{widgetConfig}=useSelector((store)=> store?.widgetSettings)
    console.info("selected combination : ",selectedCombination)
  return (
    <Box>
      <AddressCard totalCount={totalCount} languageWords={languageWords} />
      {selectedCombination?.some((item) => item?.isBefore == true) && (
        <CombinationCard
          data={selectedCombination?.find((item) => item?.isBefore == true)}
          selectedDate={selectedDate}
          reservType={reservType}
          adult={adult}
          child={child}
          kid={kid}
          baby={baby}
          toddler={toddler}
          languageWords={languageWords}
          totalCount={totalCount}
        />
      )}
      <YourBookingCard
        selectedDate={selectedDate}
        reservType={reservType}
        adult={adult}
        child={child}
        kid={kid}
        baby={baby}
        toddler={toddler}
        languageWords={languageWords}
        selectedExtraProduct={selectedExtraProduct}
        time={time}
        totalCostYourBooking={totalCostYourBooking}
      />
      {selectedCombination?.some((item) => item?.isBefore == false) && (
        <CombinationCard
          data={selectedCombination?.find((item) => item?.isBefore == false)}
          selectedDate={selectedDate}
          reservType={reservType}
          adult={adult}
          child={child}
          kid={kid}
          baby={baby}
          toddler={toddler}
          languageWords={languageWords}
          totalCount={totalCount}
        />
      )}
      {totalCount < widgetConfig?.reservationRequestMin && (
        <PaymentCard
          transactionDetails={transactionDetails}
          languageWords={languageWords}
          transactionPrice={transactionPrice}
          excludingVat={excludingVat}
          totalVat={totalVat}
          totalIncludingVAT={totalIncludingVAT}
        />
      )}
    </Box>
  );
};

export default CardSection;
